import { render, staticRenderFns } from "./serviceHallEdit.vue?vue&type=template&id=4dcf0585&scoped=true"
import script from "./serviceHallEdit.vue?vue&type=script&lang=js"
export * from "./serviceHallEdit.vue?vue&type=script&lang=js"
import style0 from "./serviceHallEdit.vue?vue&type=style&index=0&id=4dcf0585&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcf0585",
  null
  
)

export default component.exports